// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1LauV","select":"Header_select__1oCB2","clinic":"Header_clinic__JhVRP"};